import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import DoubleHelixPiercingImage from '../../Assets/Piercing Services/double helix piercing (3).png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function DoubleHelixPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Double Helix Piercing UAE | 250 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Double Helix Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Double Helix Piercing 2500 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={DoubleHelixPiercingImage} alt="Double Helix Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Double Helix Piercing</h3>

          <p>
            Upgrade your ear styling with our professional double helix piercing services in the UAE, available at an affordable price of 250 AED. Double helix piercing is a trendy and eye-catching option that features two cartilage piercings placed along the upper outer edge of the ear, creating a layered and modern look. This stylish piercing is perfect for individuals who want to add extra edge and dimension to their ear design while maintaining a sleek and elegant appearance. Whether you prefer matching studs, delicate hoops, or a combination of both, our expert specialists ensure precise placement for a balanced and aesthetically pleasing result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each double helix piercing with accuracy and care. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. With advanced techniques designed to reduce discomfort, we make sure your piercing process is quick, efficient, and as pain-minimized as possible.
          </p>

          <p>
            Double helix piercing is ideal for those who want to elevate their ear styling with a bold yet refined touch. It pairs beautifully with other piercings such as lobe, tragus, or conch, allowing you to create a curated and personalized ear look. Our specialists take the time to understand your style preferences and guide you in selecting the best placement and jewelry combinations to achieve your desired aesthetic. Whether you’re going for a minimal stacked look or a more striking layered design, we tailor the experience to suit your vision.
          </p>

          <p>
            The procedure is typically completed within a short time, even with two piercings, making it a convenient option for clients with busy schedules. We also provide high-quality, hypoallergenic starter jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a comfortable healing process. Our goal is to deliver not only a stylish result but also a safe and smooth healing journey.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident throughout their visit. We understand that cartilage piercings can feel intimidating, especially when getting multiple piercings, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a positive and comfortable experience.
          </p>

          <p>
            Aftercare is an essential part of maintaining your double helix piercing, and we provide detailed instructions to help you care for it properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. With proper aftercare, your double helix piercing will heal effectively and remain a stylish addition to your look.
          </p>

          <p>
            Our double helix piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Our double helix piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Double Helix Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default DoubleHelixPiercing;